export default "__VITE_ASSET__BHef2Hix__"